// extracted by mini-css-extract-plugin
var _1 = "BirdviewChartCatalogGroup-modulegroup__ZbruK";
var _2 = "BirdviewChartCatalogGroup-moduletitle__CuDb8";
export { _1 as "group", _2 as "title" }
